import { render } from "./side-nav-inner-toolbar.vue?vue&type=template&id=37f2744d"
import script from "./side-nav-inner-toolbar.vue?vue&type=script&lang=js"
export * from "./side-nav-inner-toolbar.vue?vue&type=script&lang=js"

import "./side-nav-inner-toolbar.vue?vue&type=style&index=0&id=37f2744d&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__